import { Bike, BabyCarriage, Ski, PetInHold, PetInCargo } from '@websky/core';
export const shirakEquipmentIcons = {
    '039': BabyCarriage,
    '07T': Ski,
    '051': Bike,
    '021': PetInHold,
    '0BS': PetInCargo
};
